import api from '@/utils/http/axios'
// import { NO_PREFIX_URL } from '@/utils/http/base-url'
export default {
  /**
  * 上传文件
  */
  uploadFile (params = {}, config = {}) {
    return api.post('/api/file/upload-ext', params, config, 'FormData')
  },
  /**
  * 下载文件
  */
  downloadFile (params = {}, config = {}) {
    return api.get('/api/file/download', params, {
      responseType: 'blob',
      ...config
    })
  }
}
